import Vue from 'vue'
import App from './App.vue'
import i18n from './lang'
import VueTypedJs from 'vue-typed-js'

Vue.config.productionTip = false
Vue.use(VueTypedJs)

new Vue({
  render: h => h(App),
  i18n
}).$mount('#app')
